import {createAction, createSlice} from '@reduxjs/toolkit';

export const pobReportInitialState = {
  priorityProducts: [] as any[],
  priorityProductsLoading: false,
  averageSalePrices: [] as any[],
  averageSalePricesLoading: false,
  activeSkuData: [] as any[],
  activeSkuDataLoading: false,
};

export const fetchPriorityProductsCreator = createAction<any>(
  'POB_MANAGEMENT/FETCH_PRIORITY_PRODUCTS',
);

export const fetchPriorityProductsCreatorTypeName =
  fetchPriorityProductsCreator({}).type;

export const fetchAverageSalePricesCreator = createAction<any>(
  'POB_MANAGEMENT/FETCH_AVERAGE_SALE_PRICES',
);

export const fetchAverageSalePricesCreatorTypeName =
  fetchAverageSalePricesCreator({}).type;

export const savePobMasterDataCreator = createAction<any>(
  'POB_MANAGEMENT/SAVE_POB_MASTER_DATA',
);

export const savePobMasterDataCreatorTypeName =
  savePobMasterDataCreator({}).type;

export const fetchActiveSkuDataCreator = createAction<any>(
  'POB_MANAGEMENT/FETCH_ACTIVE_SKU_DATA',
);

export const fetchActiveSkuDataCreatorTypeName =
  fetchActiveSkuDataCreator({}).type;

export const updatePriorityProductsCreator = createAction<any>(
  'POB_MANAGEMENT/UPDATE_PRIORITY_PRODUCTS',
);

export const updatePriorityProductsCreatorTypeName =
  updatePriorityProductsCreator({}).type;

export const updateAverageSalePriceCreator = createAction<any>(
  'POB_MANAGEMENT/UPDATE_AVERAGE_SALE_PRICE',
);

export const updateAverageSalePriceCreatorTypeName =
  updateAverageSalePriceCreator({}).type;

const pobReportHandler = createSlice({
  name: 'POB_MANAGEMENT_SLICE',
  initialState: pobReportInitialState,
  reducers: {
    setPriorityProducts: (prevState, action) => {
      const {payload} = action;
      return {...prevState, priorityProducts: payload};
    },
    setPriorityProductsLoading: (prevState, action) => {
      const {payload} = action;
      return {...prevState, priorityProductsLoading: payload};
    },
    setAverageSalePrices: (prevState, action) => {
      const {payload} = action;
      return {...prevState, averageSalePrices: payload};
    },
    setAverageSalePricesLoading: (prevState, action) => {
      const {payload} = action;
      return {...prevState, averageSalePricesLoading: payload};
    },
    setActiveSkuData: (prevState, action) => {
      const {payload} = action;
      return {...prevState, activeSkuData: payload};
    },
    setActiveSkuDataLoading: (prevState, action) => {
      const {payload} = action;
      return {...prevState, activeSkuDataLoading: payload};
    },
  },
});
export const pobReportActions = pobReportHandler.actions;
export const pobReportReducer = pobReportHandler.reducer;
